export const RuLocale = {
    page: {
        txtTitle: 'SHIRITORI | Легко учите японскую лексику онлайн с веселой игрой しらとり',
    },
    common: {
        txtLogoAlt: 'Поезд Shiritori',
    },
    header: {
        txtLeave: 'ПОКИНУТЬ ИГРУ',
    },
    dialog: {
        leave: {
            txtTitle: 'Покинуть эту игру?',
            btnStay: 'ОСТАТЬСЯ В ИГРЕ',
            btnLeave: 'ПОКИНУТЬ И СДАТЬСЯ',
        },
    },
    home: {
        btnNewGame: 'НОВАЯ ИГРА',
        btnMainMenu: 'ГЛАВНОЕ МЕНЮ',
        btnJoinGame: 'ВОЙТИ',
        btnReturnToGame: 'ВЕРНУТЬСЯ В ИГРУ',
    },
    create: {
        headingNamePrompt: 'Как вас назвать?',
        placeholderName: 'Ваше имя',
        btnOk: 'ОК',
    },
    join: {
        placeholderName: 'Ваше имя',
        placeholderGameId: 'id игры',
        btnJoinGame: 'ВОЙТИ',
    },
    configure: {
        header: 'НАСТРОЙКА ИГРЫ',
        labelExpectedPlayers: 'Количество игроков',
        labelBoardSize: 'Размер поля',
        labelWordList: 'Список слов',
        labelAllowHints: 'Разрешить подсказки',
        labelTurnTimer: 'Таймер хода',
        optionNoTimer: 'Без таймера',
        optionTimer: 'Таймер',
        unitSeconds: 'с',
        btnStartGame: 'СТАРТ',
        toastCreateError: 'Ошибка: не удалось создать эту игру',
        toastTryAgain: 'Ошибка: попробуйте еще раз позже.',
    },
    game: {
        lobby: {
            btnReady: 'Готов',
            txtShareInvite: 'Поделитесь этим кодом с друзьями!',
            txtPlayer: 'Игрок',
            txtTeam: 'Команда',
        },
        message: {
            noSuchGame: 'Такой игры не существует',
            txtLoading: 'Загрузка...',
            txtCannotJoin: 'Не удалось присоединиться к игре',
        },
        gameplay: {
            board: {
                timeoutTitle: 'ВРЕМЯ',
                timeoutSubtitle: 'вышло',
            },
            wordSearch: {
                multipleMatches: 'НАЙДЕНО НЕСКОЛЬКО СОВПАДЕНИЙ!',
                yourTurn: 'ВАШ ХОД',
                placeholder: 'Какое слово сыграем?',
                playAction: 'ИГРАТЬ',
                timerSeconds: '{{seconds}}с',
                toastNoSuchWord: 'Такого слова нет!',
                toastCantPlay: 'Это слово нельзя сыграть!',
                toastPlayed: 'Сыграно "{{word}}"',
                toastPlayFailed: 'Упс, не удалось сыграть это слово!',
                validation: {
                    syllableMismatch: 'Начальный слог не совпадает',
                    missingLastWord: 'В прошлом ходе нет слова',
                    wordNotInList: 'Слова нет в выбранном списке',
                }
            },
            spectate: {
                waitingOn: 'Ожидаем {{player}}',
                timeLeft: 'Осталось времени: {{seconds}}с',
            },
            endGame: {
                header: 'ИГРА ОКОНЧЕНА',
                viewResults: 'ПОКАЗАТЬ РЕЗУЛЬТАТЫ',
                statsTotalTime: 'Общее время игры',
                statsSquaresFilled: 'Заполнено клеток',
                statsLongestWord: 'Самое длинное слово',
                share: 'Поделиться',
                sharing: 'Публикация...',
                ariaCloseLabel: 'Закрыть окно завершения игры',
            }
        },
    },
    footer: {
        linkHowToPlay: 'Как играть',
        linkPrivacyPolicy: 'Политика конфиденциальности',
        txtAllRightsReserved: 'Все права защищены.',
    },
    howToPlay: {
        title: 'Как играть в Shiritori しりとり (shiritori)',
        btnPlayNow: 'Играть сейчас!',
        btnReturnToGame: 'Вернуться в игру:',
        description1: 'b|Shiritori| это наша онлайн-многопользовательская версия японской игры-цепочки слов しりとり. Собирайте поле из картинок и тренируйте лексику с друзьями или в одиночку.',
        description2: 'Создайте или присоединитесь к игре, выберите размер поля, набор картинок и список слов, затем наперегонки заполняйте сетку правильными словами, пока кто-то не ошибется.',
        gameSetup: {
            title: 'Создать или присоединиться к игре',
            p1: 'Играйте в одиночку или пригласите до 9 друзей (всего 10 игроков) по ссылке или коду игры.',
            p2: 'Выберите параметры: размер поля (3x3, 5x5, 7x7), узор/цвет фона, набор картинок и список слов для изучения.',
            p3: 'Друзья открывают ссылку, выбирают ник и появляются в лобби; игра начинается, когда подключится ожидаемое число игроков.',
            p4: 'Опоздавшие могут смотреть текущий матч в режиме только просмотра.',
        },
        objective: {
            title: 'Цель',
            p1: 'Стройте цепочку так, чтобы каждое новое слово начиналось с последнего слога предыдущего, заполните поле и никогда не заканчивайте слово на ん.',
        },
        wordRules: {
            title: 'Допустимые слова',
            p1: 'Вводите в кана или ромадзи; перед проверкой ромадзи преобразуется в хирагану на стороне клиента.',
            p2: 'Слова должны быть в выбранном списке (100/1000 частых, еда, спорт и т. д.), а после хода показывается их значение.',
            p3: 'Использованные слова блокируются. Если омофоны разрешены, можно выбрать неиспользованный вариант с правильной картинкой.',
            li1: 'Начинается с требуемого слога прошлого хода',
            li2: 'Не заканчивается на ん (n)',
            li3: 'Входит в выбранный список слов',
            li4: 'Ранее не разыгрывалось в этой игре',
            li5: 'Использует допустимый омофон/картинку, когда это правило включено',
            p4: 'Каждый корректный ход кладет картинку на поле по порядку, заполняя его слева направо и сверху вниз. e|Пример:_そば_→_バス|',
        },
        turnFlow: {
            title: 'Ходы и тайминг',
            p1: 'Ходы идут по списку игроков; когда вы становитесь активным, у вас есть до 10 секунд с момента, когда увидели свой ход.',
            p2: 'Shiritori ждет, пока следующий игрок станет активным (фокус на браузере), и только затем запускает таймер, чтобы нельзя было пропускать отсчет перезапуском или обновлением.',
            p3: 'Введите слово, следите за проверкой в реальном времени и отправьте до дедлайна. Неверная или поздняя отправка сразу завершает матч.',
        },
        boardFlow: {
            title: 'Поле, ход игры и завершение',
            p1: 'Поле показывает каждое сыгранное слово с картинкой, именем игрока и номером хода, а стрелки показывают порядок по сетке.',
            p2: 'Когда ход другого игрока, вы все равно видите требуемый начальный слог и обратный отсчет.',
            p3: 'Если все клетки заполнены корректными словами, игра завершается успешно и показывает готовое поле для публикации.',
            p4: 'Если до истечения времени не отправлен корректный ход, игра заканчивается с итогом о том, кто вышел по тайм-ауту или сыграл неверное слово.',
        },
        summary: {
            title: 'Итог',
            p1: 'Shiritori делает shiritori быстрым и наглядным: короткие раунды, понятные правила и визуальные ассоциации помогают держать цепочку живой.',
            p2: 'Поделитесь ссылкой, заполните поле и узнайте, насколько длинной может быть ваша цепочка слов.',
        }
    },
    bugsAndFeatures: {
        title: 'Баг-репорты и новые функции',
        p1: 'Мы сделали эту игру как другой способ играть в классическую k|しりとり.| Как команда, которая любит игры, мы постоянно ищем способы сделать ее лучше и интереснее.',
        cta: {
            l1: 'Кстати, нам будет очень приятно, если вы поможете ',
            a: 'поделиться нашей игрой с друзьями',
            l2: ' в соцсетях!'
        },
        p2: 'Если вы встретили баг или хотите предложить новую функцию, напишите нам!',
        bugs: {
            title: 'Баги',
            p1: 'Пожалуйста, сообщайте о странном поведении, ошибках и багах прямо в нашем публичном a|https://github.com/indexinteractive/|репозитории_GitHub| . Обязательно добавьте как можно больше деталей, включая шаги для воспроизведения.'
        },
        features: {
            title: 'Новые функции',
            p1: 'Если у вас есть идеи по новым функциям, улучшениям или игровым механикам, создайте новую дискуссию на странице a|https://github.com/indexinteractive/|GitHub_Discussions| .'
        }
    },
    share: {
        title: 'Shiritori | Легко учите японскую лексику онлайн с веселой игрой しらとり - SHIRITORI',
        text: 'Играйте в Shiritori онлайн с друзьями или случайными игроками. Регистрация не нужна!',
    }
};
